import { P } from "@/components/ui/Heading";
import { Property } from "@/interfaces/property.interface";
import {
  getPlaceholdJPUrl,
  getTextColorForBackground,
} from "@/lib/agency-gradient";
import clsx from "clsx";
import Image from "next/image";

export interface PropertyCaseFooterProps {
  property: Property;
}

export const PropertyCaseFooter = (props: PropertyCaseFooterProps) => {
  const { property } = props;

  const agentNameFallback = property.agent?.name
    ? property.agent?.name[0]
    : "A";

  const textColor = getTextColorForBackground(property.agency.color ?? "black");

  return (
    <div
      className="flex h-9 w-full items-center justify-end p-3 px-2 shadow-xl border-t"
      style={{
        background: property.agency.color,
      }}
    >
      <P
        className={clsx("text-sm line-clamp-1 mr-2 font-semibold", {
          "text-white": textColor === "#fff",
          "text-black": textColor === "#000",
        })}
      >
        {property.agent?.name}
      </P>
      <div className="relative z-10 mb-12 h-16 w-16">
        <Image
          src={
            property.agent?.photo ??
            getPlaceholdJPUrl(
              agentNameFallback,
              property.agency.color,
              textColor,
              100
            )
          }
          unoptimized={property.agent.photo?.startsWith("https")}
          className="rounded-full object-top object-cover border aspect-auto"
          alt={property.agent?.name}
          fill
          fetchPriority="high"
          priority
          sizes="(max-width: 768px) 20vw, 5vw"
        />
      </div>
    </div>
  );
};
